import type { TrackEventProps } from "src/components/adobeAnalytics"

export const TRACK_CUSTOMER_SELECT_FROM_CRM: TrackEventProps = {
	action: "select_customer_from_crm",
	category: "offer",
}
export const TRACK_CREATE_OFFER: TrackEventProps = { action: "create", category: "offer" }

export const TRACK_CREATE_OFFER_AS_NEW: TrackEventProps = { action: "create_as_new", category: "offer" }

export const TRACK_UPDATE_OFFER: TrackEventProps = { action: "update", category: "offer" }

export const TRACK_OPEN_CONFIGURATOR: TrackEventProps = { action: "open_configurator", category: "offer" }

export const TRACK_OPEN_OFFER_DETAILS: TrackEventProps = { action: "open_details", category: "offer" }

export const TRACK_TRANSFER_VEHICLE: TrackEventProps = { action: "transfer_vehicle", category: "offer" }
export const TRACK_TRANSFER_OFFER: TrackEventProps = { action: "transfer_offer", category: "offer" }
